export const globalRoles = {
  admin: "Admin",
  superAdmin: "SuperAdmin",
  manager: "Manager",
  associate: "Associate",
};

export const roleTexts = {
  Admin: "Administrator",
  SuperAdmin: "Super Admin",
  Manager: "Manager",
  Associate: "Associate",
};

export const workcenterMilestoneStatuses ={
  completed : "Completed",
  "Over Due":"Over Due",
  "Up Coming":"Up Coming",
  "Due Today":"Due Today"
}